import * as Joi from "joi";
import { Moment } from 'moment';
import { Column, Entity, JoinColumn, ManyToOne } from 'typeorm';
import { GenPartial, momentTransformer } from 'typeormgen';
import PdMessage from '../pd-messages/pd-messages.entity';
import Picture from '../pictures/picture.entity';
import ProdBase from '../prod-base.entity';

@Entity('pd_message_pictures')
export default class PdMessagePicture extends ProdBase {
	static readonly tableName = 'pd_message_pictures';

	@Column('int')
	prod_id: number;

	@Column('int')
	message_id: number;

	@Column('int')
	picture_id: number;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	last_updated_time: Moment;

	@Column('int')
	last_updated_user: number;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	date_created: Moment;

	@Column('int')
	created_by: number;

	@ManyToOne((type) => PdMessage, (pdMessage) => pdMessage.pdMessagePicture)
	@JoinColumn({
		name: 'message_id',
	})
	pdMessage: PdMessage;

	@ManyToOne((type) => Picture, (picture) => picture.pdMessagePictures)
	@JoinColumn({
		name: 'picture_id',
	})
	picture: Picture;

	static rules() {
		return {
			...super.rules(),
			prod_id: Joi.number().integer().allow(null),
			picture_id: Joi.number().integer().allow(null),
			message_id: Joi.number().integer().allow(null),
			last_updated_time: Joi.date().allow(null),
			last_updated_user: Joi.number().integer(),
			date_created: Joi.date().allow(null),
			created_by: Joi.number().integer(),
		};
	}

	toJSON() {
		return {
			...super.toJSON(),
			prod_id: this.prod_id,
			picture_id: this.picture_id,
			message_id: this.message_id,
			last_updated_time: this.last_updated_time,
			last_updated_user: this.last_updated_user,
			date_created: this.date_created,
			created_by: this.created_by,
		};
	}

	assign(props?: GenPartial<PdMessagePicture>) {
		super.assign(props);

		if (props) {
			if (typeof props.last_updated_time !== 'undefined') {
				this.last_updated_time = momentTransformer.from(
					props.last_updated_time
				);
			}
			if (typeof props.date_created !== 'undefined') {
				this.date_created = momentTransformer.from(props.date_created);
			}
		}
	}

	constructor(props?: GenPartial<PdMessagePicture>) {
		super(props);
	}

	getUploadDate() {
		return this.date_created
			? this.date_created.local().format('MMMM DD, YYYY')
			: '';
	}
}
